import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useTitle = (defaultTitle: string = 'Equilibre Production-Vente') => {
	const location = useLocation();
	useEffect(() => {
		document.title = location.state?.currentPage ?? defaultTitle;
	}, [location]);
};
